import { createRootRoute, createRoute, createRouter } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { AppShell } from "./components/app-shell";
import { Empty } from "./components/states";
import { NewProgram } from "./features/programs/new-program";
import { ProgramPage } from "./features/programs/program-page";

function Home() {
  const { t } = useTranslation();
  return (
    <div className="space-y-2 p-6">
      <p className="text-sm text-muted-foreground">{t("app.tagline")}</p>
      <Empty>{t("programs.pick")}</Empty>
    </div>
  );
}

const rootRoute = createRootRoute({ component: AppShell });
const homeRoute = createRoute({ getParentRoute: () => rootRoute, path: "/", component: Home });
const newProgramRoute = createRoute({ getParentRoute: () => rootRoute, path: "/programs/new", component: NewProgram });
export const programRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/programs/$programId",
  validateSearch: (search: Record<string, unknown>): { run?: string } => (typeof search.run === "string" ? { run: search.run } : {}),
  component: function ProgramRouteView() {
    const { programId } = programRoute.useParams();
    const { run } = programRoute.useSearch();
    return <ProgramPage key={programId} programId={programId} runId={run} />;
  },
});

const routeTree = rootRoute.addChildren([homeRoute, newProgramRoute, programRoute]);

export const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
